module.exports = __webpack_public_path__ + "static/media/antiwrinkle.318421f3.svg";